import React, { useState } from "react";

import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";

import handleSessionExpired from "@features/auth/handleSessionExpired";
import {
  captureMutationException,
  captureQueryException,
} from "@services/sentry";

import safeStructuralSharing from "./safeStructuralSharing";

const QueryClientProviderWrapper = (props: { children: React.ReactNode }) => {
  // make client persistent
  const [client] = useState(
    new QueryClient({
      queryCache: new QueryCache({
        onError: (error, query) => {
          // Catch 401, invalid_token errors and set to expire
          if (error.response?.status === 401) {
            handleSessionExpired();
            return;
          }
          captureQueryException(error, query);
        },
      }),
      mutationCache: new MutationCache({
        onError: (error, _variables, _context, mutation) => {
          // Catch 401, invalid_token errors and set to expire
          if (error.response?.status === 401) {
            handleSessionExpired();
            return;
          }
          captureMutationException(error, mutation);
        },
      }),
      defaultOptions: {
        queries: {
          // JSON:API responses are deserialized into graphs that may contain
          // circular references, so we use a cycle-safe structural sharing
          // implementation instead of react-query's default.
          structuralSharing: safeStructuralSharing,
          retry: false,
        },
        mutations: {},
      },
    })
  );
  return <QueryClientProvider client={client} {...props} />;
};

export default QueryClientProviderWrapper;
